export default {
  docs: () => import("C:/code/treqit/docs/layouts/docs.vue").then(m => m.default || m)
}